module.exports = __webpack_public_path__ + "img/goal-net.a51a485e.svg";